package gr.tech.pdfgenerator.models

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf

data class ProposalCalculationsDTO(
    //Linked Values
    var totalROI: Double = 0.0,
    var annualizedROI: Double = 0.0,
    var simplePayback: Double = 0.0,

    var replaceFixBulbs: Long = 0,
    var projectCost: Long = 0,
    var salesTax: Long = 0,
    var totalProjectCost: Long = 0,
    var rebates: Long = 0,               //Not denoting as negative here, as it is still the rebate amount. Some areas in code call for this number to be negative. Added negative - wherever needed.
    var netProjectCost: Long = 0,

    var energySavingsLighting: Long = 0,
    var energySavingsHVAC: Long = 0,
    var maintenanceSavings: Long = 0,
    var totalAnnualSavings: Long = 0,
    var totalSavingsTenYears: Long = 0,

    //Cash Flow
    var cashflowProjectCost: Long = 0,
    var energySavingList: List<Long> = listOf(0L),
    var hvacSavingsList:List<Long> = listOf(0L),
    var netCashFlowList: List<Long> = listOf(0L),
    var cummCashFlowList: List<Long> = listOf(0L),
    var irrInput: List<Long> = listOf(0L),
    var irrInput2: List<Long> = listOf(0L),
    var irrInput3: List<Long> = listOf(0L),

    //financing
    var financeToggle: Boolean = false, //toggle option
    var financedAmount: Long = 0, //summary, rebate amount
    var upfrontNoFinance: Long = 0, //summary, total project cost
    var upfrontFinanced: Long = 0,
    var returnNoFinance: Double = 0.0,
    var returnFinanced: Double = 0.0,

    //cost waiting
    var costInYearsList: List<Long> = listOf(0L),

    //savings analysis
    var annualSavings: Long = 0,

    var baselineCostSavings: Double = 0.0,
    var baselineEnergyCosts: Long = 0,
    var baselineMaintenance: Long = 0,
    var baselineHVAC: Long = 0,
    var baselineTotal: Long = 0,

    var ledCostSavings: Double = 0.0,
    var ledEnergyCosts: Long = 0,
    var ledMaintenance: Long = 0,
    var ledHVAC: Long = 0,
    var ledTotal: Long = 0,

    //environmental impacts
    var totalEnergySavings: Double = 0.0,
    var baselineCo2Amount: Double = 0.0,
    var co2Reduced: Double = 0.0,
    var co2ReducedPercentage: Double = 0.0,
    var carsRemoved: Long = 0,
    var treesPlanted: Long = 0,

    var usYearlyTotalkWh: Long = 4100000000000,
    var usYearlyTotalco2: Long = 1650000000,
    var tonsCo2kWh: Double = 0.0,
    //Source: https://www.eia.gov/tools/faqs/faq.php?id=74&t=11

    var vehicleCo2Year: Double = 4.6,
    //Source: https://www.epa.gov/greenvehicles/greenhouse-gas-emissions-typical-passenger-vehicle#:~:text=typical%20passenger%20vehicle%3F-,A%20typical%20passenger%20vehicle%20emits%20about%204.6%20metric%20tons%20of,8%2C887%20grams%20of%20CO2.

    var treeCo2Year: Double = 0.02177
    //Source: https://www.usda.gov/media/blog/2015/03/17/power-one-tree-very-air-we-breathe#:~:text=According%20to%20the%20Arbor%20Day,the%20very%20air%20we%20breathe.
) {
    override fun toString(): String {
        return """
            |ProposalCalculationsDTO(
            |  Total ROI                        : $totalROI
            |  Annualized ROI                   : $annualizedROI
            |  Simple Payback                   : $simplePayback
            |  Replace Fix Bulbs                : $replaceFixBulbs
            |  Project Cost                     : $projectCost
            |  Sales Tax                        : $salesTax
            |  Total Project Cost               : $totalProjectCost
            |  Rebates                          : $rebates
            |  Net Project Cost                 : $netProjectCost
            |  Energy Savings (Lighting)        : $energySavingsLighting
            |  Energy Savings (HVAC)            : $energySavingsHVAC
            |  Maintenance Savings              : $maintenanceSavings
            |  Total Annual Savings             : $totalAnnualSavings
            |  Total Savings (10 Years)         : $totalSavingsTenYears
            |
            |  Financing:
            |  - Finance Toggle                 : $financeToggle
            |  - Financed Amount                : $financedAmount
            |  - Upfront (No Finance)           : $upfrontNoFinance
            |  - Upfront (Financed)             : $upfrontFinanced
            |  - Return (No Finance)            : $returnNoFinance
            |  - Return (Financed)              : $returnFinanced
            |
            |  Environmental Impacts:
            |  - Total Energy Savings           : $totalEnergySavings
            |  - Baseline CO2 Amount            : $baselineCo2Amount
            |  - CO2 Reduced                    : $co2Reduced
            |  - CO2 Reduced Percentage         : $co2ReducedPercentage
            |  - Cars Removed                   : $carsRemoved
            |  - Trees Planted                  : $treesPlanted
            |)
        """.trimMargin()
    }
}